

















































































































































































import AdminClassifiedService from '~/services/admin/classified/AdminClassifiedService'
import InternalPageUrlService from '~/services/url/InternalPageUrlService'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import {
  computed,
  defineComponent,
  onMounted,
  ref
} from '@nuxtjs/composition-api'
import { useDeps } from '~/compositions/dependency-container'
import {
  CLASSIFIED_VIEW_NS,
  ClassifiedViewState
} from '~/store/modules/shared/classifieds/view/state'
import { useNamespacedStore } from '~/compositions/store'
import CExpandableContent from '~/components/shared/configurable/expand/CExpandableContent.vue'
import { adminTimeDistanceFromNow } from '~/utils/date'

export default defineComponent({
  components: { CCard, CExpandableContent },
  setup() {
    const perpetratorInfo = ref<any>(null)
    const loading = ref(true)

    const [adminClassifiedService, internalPageUrlService] = useDeps(
      AdminClassifiedService,
      InternalPageUrlService
    )
    const { state } = useNamespacedStore<ClassifiedViewState>(
      CLASSIFIED_VIEW_NS
    )
    const classifiedId = computed(() => state.classified!.id)
    const seller = computed(() => state.seller)
    const specifications = computed(
      () => state?.classified?.extra_specifications
    )

    const classifiedCreated = computed(() => {
      const created = specifications.value?.find(s => s.name === 'created')
      if (created?.value) {
        return adminTimeDistanceFromNow(new Date(created.value))
      }
      return null
    })

    const classifiedModified = computed(() => {
      const modified = specifications.value?.find(s => s.name === 'modified')

      if (modified?.value) {
        return adminTimeDistanceFromNow(new Date(modified.value))
      }
      return null
    })

    onMounted(() => {
      loadPerpetratorInfo()
    })

    async function loadPerpetratorInfo() {
      try {
        const data = await adminClassifiedService.getPerpetratorInfo(
          classifiedId.value
        )
        perpetratorInfo.value = data.data
      } finally {
        loading.value = false
      }
    }

    return {
      perpetratorInfo,
      loading,
      seller,
      internalPageUrlService,
      classifiedCreated,
      classifiedModified
    }
  }
})
